import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelDocumentationServicesEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelDocumentationServicesEntity
